import { LegalLayout } from "./LegalLayout";

const CONTACT_EMAIL = "bmabma79@gmail.com";

export default function DataDeletionPage() {
  return (
    <LegalLayout
      title="Data Deletion Instructions"
      lastUpdated="22 June 2026"
    >
      <p>
        African Polistas respects your right to control your personal
        information. This page explains how to request deletion of your
        personal data from our Operations Dashboard and its associated
        WhatsApp and Telegram bots.
      </p>

      <h2>What data we hold about you</h2>
      <p>
        Depending on your role, we may hold:
      </p>
      <ul>
        <li>
          Your name, username, role, and (if applicable) phone number used
          to identify you to the WhatsApp or Telegram bots.
        </li>
        <li>
          Messages, photos, and PDF documents you have sent to our bots,
          along with delivery timestamps.
        </li>
        <li>
          Audit-log entries describing changes you made through the
          dashboard or bots.
        </li>
        <li>
          Authentication identifiers from our identity provider, Clerk.
        </li>
      </ul>
      <p>
        For full detail, see our <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>How to request deletion</h2>
      <p>To request that we delete your personal data, send an email to:</p>
      <p>
        <a href={`mailto:${CONTACT_EMAIL}?subject=Data%20Deletion%20Request`}>
          {CONTACT_EMAIL}
        </a>
      </p>
      <p>Please include:</p>
      <ol>
        <li>The subject line: <em>Data Deletion Request</em>.</li>
        <li>Your full name.</li>
        <li>
          The username, email address, or phone number you used with the
          Service (so we can locate your records).
        </li>
        <li>
          A short statement confirming that you are the person whose data
          you are asking us to delete, or that you are authorised to act on
          that person&apos;s behalf.
        </li>
      </ol>

      <h2>What happens next</h2>
      <ol>
        <li>
          We will acknowledge your request within <strong>5 business days</strong>.
        </li>
        <li>
          We will verify your identity. We may ask for a small number of
          additional details to confirm your request.
        </li>
        <li>
          We will delete or anonymise your personal data within{" "}
          <strong>30 days</strong> of confirmed verification, subject to any
          legal obligation we have to retain certain records.
        </li>
        <li>
          We will email you to confirm once deletion is complete.
        </li>
      </ol>

      <h2>What we cannot delete</h2>
      <p>
        Some information may need to be retained even after a deletion
        request, including:
      </p>
      <ul>
        <li>
          Financial records (such as invoices) where we are required by law
          or accounting standards to retain them.
        </li>
        <li>
          Anonymised, aggregated statistics that do not identify you.
        </li>
        <li>
          Records related to safety incidents or ongoing legal matters.
        </li>
      </ul>

      <h2>Third parties</h2>
      <p>
        Your data may also exist within the systems of our service
        providers (Clerk, Meta/WhatsApp, Telegram, MongoDB, Sentry,
        OpenAI/Google/Anthropic). To request deletion from those providers,
        please refer to their respective privacy policies. Where you ask us
        to do so, we will forward your request to them on your behalf.
      </p>

      <h2>Contact</h2>
      <p>
        For any question about this process, contact:{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}
